import React, { useEffect, useState } from 'react';
import './App.scss';
import './style/style.scss';
import { Redirect, Route, Router, Switch } from 'react-router-dom';
import { history } from './store/store';
import { OrderStatus } from './features/order-status/OrderStatus';
import { OrderDefects } from './features/order-defects/OrderDefects';
import { Home } from './features/home/Home';
import { ClientData } from './features/client-data/ClientData';
import { RepairOptions } from './features/repair-options/RepairOptions';
import { ProductPage } from './features/product-page/ProductPage';
import { ProductList } from './features/product-list/ProductList';
import { OrderComment } from './features/order-comment/OrderComment';
import { Footer } from './components/footer/Footer';
import { HeaderStories } from './components/stories/HeaderStories';
import { OrderEnd } from './features/order-end/OrderEnd';
import { PhoneData } from './features/phone-data/PhoneData';
import { QrScan } from './features/qr-scan/QrScan';
import { Finish } from './features/finish/Finish';
import { FinishCards } from './features/finish-cards/FinishCards';
import { FinishEnvelopeTake } from './features/finish-envelope-take/FinishEnvelopeTake';
import { FinishEnvelopePut } from './features/finish-envelope-put/FinishEnvelopePut';
import { IeData } from './features/ie-data/IeData';
import { selectCategoriyVersion, selectIsNeedReload } from './features/home/homeSlice';
import { loadCategories, loadConfig, loadPhones, simProduct } from './network/actions';
import { useAppDispatch, useAppSelector } from "./hooks";
import { TimerWindow } from './features/timer-window/timerWindow';
import { AlertWindow } from './features/alert-window/AlertWindow';
import { FinishOrder } from './features/finish-order/FinishOrder';
import { FinishBuy } from './features/finish-buy/FinishBuy';
import { Splash } from './Splash';
import { SaledWindow } from './features/saled-window/saledWindow';
import { TechnicalCheck } from './features/technical-check/TechnicalCheck';
import { ConfirmPhone } from './features/confirm-phone/ConfirmPhone';
import { EmulBox } from './components/emul-box/EmulBox';
import { Stories } from './Stories';

function App() {
  const needReload = useAppSelector(selectIsNeedReload)
  const version = useAppSelector(selectCategoriyVersion)
  const dispatch = useAppDispatch();
  useEffect(() => {

    if (needReload) {
      dispatch(loadConfig())
      dispatch(loadCategories())
      dispatch(simProduct())
      dispatch(loadPhones())
    }
  }, [version])
  // <div className="App AppMini">
  return (
    <Splash>
      <Stories>
        <div className="App">
          <header className="App-header">
          </header>
          <div className="main-layout">

            <Router history={history}>
              {/* <Header /> */}
              <HeaderStories />
            </Router>
            <Router history={history}>
              <Switch>
                <Route path="/" exact render={() => (
                  <AlertWindow>
                    <SaledWindow>
                      <Home />
                    </SaledWindow>
                  </AlertWindow>
                )
                } />
                <Route path="/order-defects" exact render={() => (
                  <AlertWindow>
                    <TimerWindow duration={60 * 1000}>
                      <OrderDefects />
                    </TimerWindow>
                  </AlertWindow>
                )} />
                <Route path="/order-status" exact render={() =>
                  <AlertWindow>
                    <OrderStatus />
                  </AlertWindow>
                } />
                <Route path="/order-comment" exact render={() =>
                  <AlertWindow>
                    <TimerWindow duration={60 * 1000}>
                      <OrderComment />
                    </TimerWindow>
                  </AlertWindow>
                } />
                <Route path="/order-end" exact render={() =>
                  <AlertWindow>
                    <TimerWindow duration={60 * 1000}>
                      <OrderEnd />
                    </TimerWindow>
                  </AlertWindow>
                } />
                <Route path="/client-data" exact render={() =>
                  <AlertWindow>
                    <TimerWindow duration={60 * 1000}>
                      <ClientData />
                    </TimerWindow>
                  </AlertWindow>
                } />
                <Route path="/confirm-phone" exact render={() =>
                  <AlertWindow>
                    <TimerWindow duration={60 * 1000}>
                      <ConfirmPhone />
                    </TimerWindow>
                  </AlertWindow>
                } />
                <Route path="/phone-data" exact render={() =>
                  <AlertWindow>
                    <TimerWindow duration={60 * 1000}>
                      <PhoneData />
                    </TimerWindow>
                  </AlertWindow>
                } />
                <Route path="/repair-options" exact render={() =>
                  <AlertWindow>
                    <TimerWindow duration={60 * 1000}>
                      <RepairOptions />
                    </TimerWindow>
                  </AlertWindow>
                } />
                <Route path="/product/:id/data" exact render={() =>
                  <AlertWindow>
                    <SaledWindow>
                      <ProductPage />
                    </SaledWindow>
                  </AlertWindow>
                } />
                <Route path="/category/:id/products" exact render={() =>
                  <AlertWindow>
                    <SaledWindow>
                      <ProductList />
                    </SaledWindow>
                  </AlertWindow>
                } />
                <Route path="/qr-scan" exact render={() =>
                  <AlertWindow>
                    <TimerWindow duration={60 * 1000}>
                      <QrScan />
                    </TimerWindow>
                  </AlertWindow>
                } />
                <Route path="/finish" exact render={() => 
                  <AlertWindow>
                    <Finish />
                  </AlertWindow>
                } />
                <Route path="/finish-buy" exact render={() => 
                  <AlertWindow>
                    <FinishBuy />
                  </AlertWindow>
                } />
                <Route path="/finish-order" exact render={() => 
                  <AlertWindow>
                    <FinishOrder />
                  </AlertWindow>
                } />
                <Route path="/finish-cards" exact render={() => 
                  <AlertWindow>
                    <FinishCards />
                  </AlertWindow>
                } />
                <Route path="/finish-envelope-take" exact render={() => 
                  <AlertWindow>
                    <FinishEnvelopeTake />
                  </AlertWindow>
                } />
                <Route path="/finish-envelope-put" exact render={() => 
                  <AlertWindow>
                    <FinishEnvelopePut />
                  </AlertWindow>
                } />
                <Route path="/ie-data" exact render={() => 
                  <AlertWindow>
                    <IeData />
                  </AlertWindow>
                } />
                <Route path="/debug" exact render={() => 
                  <AlertWindow>
                    <TechnicalCheck />
                  </AlertWindow>
                } />
                <Route path="/emul" exact render={() => 
                  <AlertWindow>
                    <EmulBox />
                  </AlertWindow>
                } />
                <Redirect to='/' />
              </Switch>
            </Router>


            <Router history={history}>
              <Footer />
            </Router>
          </div>
        </div>
      </Stories>
    </Splash>
  );
}

export default App;


